
import moment from 'moment';
import { formatAs, formatDateRange, getAsStartAndEndTimeFormat, getUserFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { RequestTypes, ShiftSegmentTypeName } from '../../../Enums';
import { MomentFormats } from '../../../utils';

export const handleChangeProposalPartial = (updateProposalPartialDates, e, val, shifts, requestType) => {
    const shift = shifts[0];
    const startDate = moment.utc(shift.startDateTime);
    const newStartDate = moment.utc(startDate).add(val[0], 'm')
    const newEndDate = moment.utc(startDate).add(val[1], 'm')
    const partialShiftLabel = generateSelectedPartialLabel(shift, newStartDate, newEndDate, RequestTypes.shiftSwap)

    updateProposalPartialDates({
        startDate: newStartDate,
        endDate: newEndDate,
        partialShiftLabel: partialShiftLabel,
    });
}

export const generateSelectedPartialLabel = (shift, startDateTime, endDateTime, requestType) => {
    let dates = {
        startDate: moment.utc(startDateTime),
        endDate: moment.utc(endDateTime)
    }
    if (requestType === RequestTypes.toCover) {
        dates = parseOverlappingDateTimeOnBreakSegments(startDateTime, endDateTime, shift.segments);
    }

    return getAsStartAndEndTimeFormat(dates.startDate.format(MomentFormats.ISO), dates.endDate.format(MomentFormats.ISO))
}


export const parseOverlappingDateTimeOnBreakSegments = (startDateTime, endDateTime, segments) => {
    let startDate = moment.utc(startDateTime)
    let endDate = moment.utc(endDateTime)
    let selectedSegments = segments.filter(segment => moment.utc(segment.startDateTime).isBetween(startDate, endDate) || moment.utc(segment.endDateTime).isBetween(startDate, endDate))
    for (let segment of selectedSegments) {
        if (segment.type === ShiftSegmentTypeName.BREAK_SEGMENT) {
            if (startDate.isBefore(moment.utc(segment.endDateTime)) && !moment.utc(segment.startDateTime).isBetween(startDate, endDate, null, '()')) {
                startDate = moment.utc(segment.endDateTime)
            }
            else if (endDate.isAfter(moment.utc(segment.startDateTime)) && !moment.utc(segment.endDateTime).isBetween(startDate, endDate, null, '()')) {
                endDate = moment.utc(segment.startDateTime);
            }
        }
    }
    return { startDate, endDate }
}

export const isPartialOfShift = (partialDates, shift) => {
    const partialStartDate = moment.utc(partialDates.startDate);
    const partialEndDate = moment.utc(partialDates.endDate);
    const shiftStartDate = moment.utc(shift.startDateTime);
    const shiftEndDate = moment.utc(shift.endDateTime);

    /** partial dates do not match shift start and end date*/
    const isPartialDifferentFromShift = !(partialStartDate.isSame(shiftStartDate) && partialEndDate.isSame(shiftEndDate));
    /** partial start date within shift, excluding edges */
    const partialStartWithinShift = partialStartDate.isBetween(shiftStartDate, shiftEndDate, 'minute', '()');
    /** partial end date within shift, excluding edges */
    const partialEndWithinShift = partialEndDate.isBetween(shiftStartDate, shiftEndDate, 'minute', '()');
    return isPartialDifferentFromShift && (partialStartWithinShift || partialEndWithinShift);
}
